import { motion } from "framer-motion";
import { useEffect, useRef, useState } from "react";

export default function EditionName() {
  const [animationKey, setAnimationKey] = useState(0);
  const svgRef = useRef<SVGSVGElement>(null);
  const [lengths, setLengths] = useState<number[]>([]);

  const paths = [
    "M35.5,59.3s-6.3,28.1-15.7,50.4c0,0-1.5,2.6,0-7.3s4.8-27.9,16.7-39.1,14.6-3.5,14.6-3.5c0,0,5.2,7.8-21.3,32.6,0,0,5.3-6,15.1-8.8s19.9-3,18.8,6.2-14.6,22.8-28.5,31.6-29.8,6.5-31.5-1.9,30.7-21.6,30.7-21.6c0,0,27.6-10.8,33.7-12.3",
    "M74.9,84s-2.9-3-6,.5-4.4,10.5-2.7,13.4,6.9-7.9,7.4-8.7,3.1-5.4,2.4-6.4-2.2,3.3-2.4,9.3,4.5,2.8,4.5,2.8c0,0,3.9-2.2,12-13.7,0,0,3.2-2.9,2.2-4.4s-2.6,3-1.8,3.5,2.6-1.6,3.5-.7,0,6.1-.5,8.2-2.7,7.1-.1,8.3,9.8-18.3,9.8-18.3c0,0-5.4,15.8-1.2,15s16.5-16.9,16.8-17.6-2,7.1,2.3,8.4,8-7.3,8.5-10.5.4-8.4-5.1-7-7.2,10-3.7,11.3,12.7-6.3,14.3-6.3",
    "M144.7,37.1s-16,48.5-11.1,51.2,17.5-20.8,17.5-20.8",
    "M129.5,66.4s6.4-.5,23.2-5.7",
    "M105.2,70.1s-.9-1-.9,1.2,1.5-.8.9-1.2Z",
    "M182.1,35.1s-.3,16.5-5.2,32-9.3,29.2-9.8,29.2c0,0-1.5,0,2.3-3.6s37.7-21.4,57.2-9.5",
    "M186.2,58.2s-3.3,10.6,2.1,11.3,8.3-9.7,8.2-13.3-2.1-5.3-4.9-4.5c0,0-5,1.4-5.6,8.1s16.4-3.3,16.4-3.3",
    "M206.7,55.3s-6.7-.7-8.7,11,19.5-13.5,19.5-13.5c0,0-2.7,6.5.6,9.2s8.2-3.8,9.2-8.8,1.4-7.1-2.9-8.8-8.8,8.6-6.9,11.1,12.8-3.6,15.9-6.1",
    "M247.3,5.9s-.3,55.1,1.4,57.7",
    "M249.7,70.2s-1.1-.6-.5,1.4,1.1-1.2.5-1.4Z",
  ];

  // Mesure réelle des longueurs
  useEffect(() => {
    if (!svgRef.current) return;

    const measured: number[] = [];
    const nodes = svgRef.current.querySelectorAll("path");

    nodes.forEach((path) => {
      measured.push((path as SVGPathElement).getTotalLength());
    });

    setLengths(measured);
  }, [animationKey]);

  // Relance toutes les 12 secondes
  useEffect(() => {
    const interval = setInterval(() => {
      setAnimationKey((prev) => prev + 1);
    }, 15000);

    return () => clearInterval(interval);
  }, []);

  const totalLength = lengths.reduce((a, b) => a + b, 0);

  if (!lengths.length) {
    return (
      <div className="flex justify-center my-6">
        <svg
          ref={svgRef}
          viewBox="0 0 262.7 133"
          className="w-96 md:w-[600px] opacity-0"
        >
          {paths.map((d, i) => (
            <path key={i} d={d} fill="none" stroke="transparent" />
          ))}
        </svg>
      </div>
    );
  }

  return (
    <div className="flex justify-center md:-mt-32 md:mb-36 -mt-20 mb-20">
      <svg
        key={animationKey}
        ref={svgRef}
        viewBox="0 0 262.7 133"
        className="w-96 md:w-[600px] drop-shadow-[0_0_6px_rgba(20,96,126,0.6)]"
      >
        {paths.map((d, index) => {
          const length = lengths[index] || 100;
          const proportion = totalLength ? length / totalLength : 0.1;

          return (
            <motion.path
              key={index}
              d={d}
              fill="none"
              stroke="#FAE810"
              strokeWidth="4"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeDasharray={length}
              strokeDashoffset={length}
              initial={{ strokeDashoffset: length }}
              animate={{ strokeDashoffset: 0 }}
              transition={{
                duration: proportion * 6,
                delay: lengths
                  .slice(0, index)
                  .reduce((a, b) => a + b, 0) /
                  totalLength *
                  6,
                ease: "easeInOut"
              }}
            />
          );
        })}
      </svg>
    </div>
  );
}
